module.exports = __webpack_public_path__ + "img/s8.096a53c.png";